import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiDeRegister = async (mcid, key, deviceID, tracking) => {
    let form = new FormData();

    form.append("mcid", mcid);
    form.append("key", key);

    if (typeof tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", tracking.pathname);
        form.append("pagevia", tracking.pagevia);
        form.append("action", 'deregister devices');
        form.append("os", tracking.os);
        form.append("ua", tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const request = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "deRegisterDevice"
            },
            data: form
        });

        return request.data;
    } catch (error) {
        throw error;
    }
};